import React, { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";

import "./EmailThreadMessageDrawer.less";

import { DrawerProps } from "antd/lib/drawer";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import { FormComponentProps } from "@ant-design/compatible/lib/form";
import { Form } from "@ant-design/compatible";
import Select from "antd/lib/select";
import Upload, { UploadChangeParam } from "antd/lib/upload";
import { UploadFile, RcFile } from "antd/lib/upload/interface";
import Popover from "antd/lib/popover";
import Skeleton from "antd/lib/skeleton";

import {
	ZomentumWindow,
	DefaultErrorMessage,
	ZomentumRoutes,
	ZomentumStorageKeys,
	FileUploadStatus
} from "@/Contracts";
import {
	TinyMceOptions,
	TinyMcePlugins,
	checkForDocumentUrlPresent,
	emailRegex
} from "@/Contracts/Utils";
import { AuthToken } from "@/Contracts/Login";

import DocumentExpiration from "./FooterActivities/DocumentExpiration";

import ZMergeTagCascadeDropdown from "@molecules/ZMergeTag/ZMergeTagCascadeDropdown";

import {
	SendEmailThreadMessageFormValues,
	EmailThreadMessage,
	EmailThreadMessageEditorType,
	SendEmailThreadMessageRequest,
	SendDocumentEmailThreadMessageRequest,
	EmailThreadParticipant,
	EmailThreadFile,
	FetchMergeTagsRequest,
	ValidateEmailMergeTagsRequest,
	EntityType,
	GetEmailPreviewRequest,
	EmailTracking,
	EmailThreadRecipients,
	GetDocumentEmailPreviewRequest,
	EmailRecipientsTypes
} from "@/Contracts/Others/EmailThread";
import { EmailTemplateFileDetails } from "@/Contracts/EmailTemplates";
import EmailThreadActionCreators from "@/Actions/Others/EmailThread";
import DocumentReminder from "./FooterActivities/DocumentAutoReminder";
import { cache } from "@/Contracts";

import { Modal, Spin, Dropdown, Menu } from "antd";
import EmptyMergeTagsAlertModal from "@pages/Documents/Modals/EmptyMergeTags";

import TemplatesIcon from "config/assets/DocumentsPage/TemplatesIcon.svg";
import ImportEmailTemplateModal from "./FooterActivities/ImportEmailTemplateModal";
import { EmailTemplate, CustomTemplateType } from "@/Contracts/EmailTemplates";
import EmailTemplatesActionCreators from "@/Actions/EmailTemplates";
import TrackEmail from "./FooterActivities/TrackEmail";
import {
	convertTextToMergeTag,
	checkForValidMergeTag
} from "@/Utils/MergeTags";
import EmailSignatureComponent from "./FooterActivities/EmailSignatureComponent";
import {
	DocumentDefaultPreferenceLastUsedEmail,
	EmailSignature
} from "@/Contracts/Users";
import { ConnectedEmails } from "@/Contracts/Settings";
import { MergeTagPreference } from "@/Contracts/Documents";
import { useFeatureFlag } from "@/Hooks/useFeature";
import ZTypography from "@atoms/ZTypography";

import IFRAME from "../../Iframe";
import { EFontWeights } from "@atoms/ZTypography/interface";
import ZMessage from "@molecules/ZMessage";
import {
	formatNylasIntegratedEmailId,
	nylasConnectedEmailSuffix
} from "@/V2Utils";
import UsersActionCreators from "@/Actions/User";
import ZModal from "@atoms/ZModal";
import ZSelect from "@atoms/ZSelect";
import { IOptionProps } from "@atoms/ZSelect/interface";

import ZSection from "@molecules/ZSection";
import ZButton from "@atoms/ZButton";
import ZIcon from "@atoms/ZIcon";
import { EIcons, ETwoToneIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";
import { initializeTinyMCEPrePastePrompt } from "@/Utils/tinyMCEPrePastePrompt";
import useMobileView from "@/Hooks/useMobileView";
import { GlobalState } from "@/Reducers/interface";
import { MergeTagListToSkip } from "@/Contracts/Others/MergeTags";
import {
	MERGE_TAG_END,
	MERGE_TAG_START,
	replaceMergeTagsWithId,
	updateMergeTagsDisplayName
} from "@/Utils/MergeTags";
import ZTag from "@atoms/ZTag";
import ZTooltip from "@atoms/ZTooltip";
import { isGivenDocumentOrderForm } from "@/Utils/Documents";
import {
	Modules,
	Stages,
	Steps,
	useGuideHook,
	useOnboardingSelector
} from "@/Onboarding";
import { OnboardingState } from "@/Onboarding/store/reducers";
import ZModalConfirm from "@atoms/ZModalConfirmation";
import { FormKeys } from "@/Contracts";
import SettingsActionCreators from "@/Actions/Settings";
import ZDrawer from "@molecules/ZDrawer";
import debounce from "lodash/debounce";
import useDispatch from "@/Components/Utils/useDispatch";
import { useComponentDidUpdate, useTestEnvironment } from "@/Hooks";
import { SendDocumentGuideDetail } from "./EmaiThreadlMessageDrawerClassComp";

declare let window: ZomentumWindow;

interface Props
	extends DrawerProps,
		FormComponentProps<SendEmailThreadMessageFormValues> {
	readonly isNewThread: boolean;
	readonly isDocumentMessage: boolean;
	readonly defaultRecipients: string[] | null;
	readonly emailThreadMessage: EmailThreadMessage | null;
	readonly ignoreAppendEmailSignature?: boolean;
	readonly defaultSubject?: string | null;
	readonly bodyPlaceholder?: string;
	readonly templateBody?: string | null;
	readonly templateAttachments?: EmailTemplateFileDetails[] | null;
	readonly documentId?: string | null;
	readonly opportunityId?: string | null;
	readonly clientId?: string | null;
	readonly useTemplate: boolean;
	readonly isFromDocumentsPage?: boolean;
	readonly allEmailRecipients?: EmailThreadRecipients[];
	readonly isFromEmailTemplatesPage?: boolean;
	readonly onSubmit?: (
		sendEmailThreadMessageRequest?: SendEmailThreadMessageRequest
	) => void;
	readonly onBeforeSubmit?: (
		request: SendDocumentEmailThreadMessageRequest
	) => Promise<void>;
	readonly onClose?: () => void;
	readonly refreshSalesActivities?: (
		shouldRefreshSalesActivities: boolean
	) => void;
	readonly hideReceiverMergeTag?: boolean;
	readonly sendDocumentGuideDetail?: SendDocumentGuideDetail;
	readonly purchaseOrderId?: string | null;
}

const { ZText } = ZTypography;

const EmailThreadMessageDrawer: React.FC<Props> = props => {
	const {
		isLoading,
		currentActiveDocument,
		userEmailIntegrationObj,
		emailThreadMergeTagVariables,
		emailPreview,
		otherEntityEmailPreview,
		emptyMergeTags,
		userData,
		userCompany,
		emailSignatures,
		defaultFromValues,
		companyUserList,
		isFormEdited
	} = useSelector((state: GlobalState) => {
		const userData = state.user.userData;
		const userEmailIntegrationObj =
			state.user.userCompany.integrations.email?.find(
				e => e.user_id === userData.id
			);

		return {
			isLoading:
				state.emailThread.isLoading ||
				state.recentActivityFeed.isLoading ||
				state.user.isLoading ||
				state.settings.isLoading,
			documentExpiryDetails:
				state.documents.currentActiveDocument?.document_expiry_details,
			currentActiveDocument: state.documents.currentActiveDocument,
			currentActiveAssessment: state.assessments.currentActiveAssessment,
			currentActiveOpportunity:
				state.opportunities.currentActiveOpportunity,
			userEmailIntegrationObj,
			emailThreadMergeTagVariables:
				state.emailThread.emailMergeTagsSystemVariable,
			emailPreview: state.emailThread.documentEmailPreview,
			otherEntityEmailPreview: state.emailThread.otherEntityEmailPreview,
			emptyMergeTags: state.emailThread.emptyMergeTags,
			userData,
			userCompany: state.user.userCompany,
			emailSignatures: state.user.emailSignatures,
			defaultFromValues: {
				email:
					process.env.REACT_APP_DEFAULT_EMAIL ??
					"noreply@zomentum.com",
				id: state.user.userData.id,
				name: state.user.userData.name.full
			},
			companyUserList: state.user.companyUserList,
			isFormEdited: state.settings.isFormEdited
		};
	});
	const isMobileView = useMobileView();
	const isNewDocumentSendView = useFeatureFlag("new_document_send_view");
	const movePreferencesToGlobal = useFeatureFlag("move_preferences_global");
	const isTestEnv = useTestEnvironment();
	const sendDocUsingNylasFlag =
		useFeatureFlag("send_doc_using_nylas") && !isTestEnv;

	const history = useHistory();

	const isSendDocumentEmailGuideActive = useOnboardingSelector(
		(state: OnboardingState) => {
			const { activeModule, activeStage, activeStep } =
				state.currentGuideProgress;
			return (
				activeModule === Modules.DOCUMENT &&
				activeStage === Stages.EXPLORE_EDITOR &&
				Steps.SHOW_SEND_EMAIL === activeStep
			);
		}
	);

	const {
		GuideUI: SendDocumentEmailGuideUI,
		handleNext: handleSendDocumentEmailNext,
		stepDetail,
		handleGuideVisiblity
	} = useGuideHook({
		stageId: Stages.EXPLORE_EDITOR,
		stepId: Steps.SHOW_SEND_EMAIL,
		entityId: currentActiveDocument?.id
	});

	const targetId = stepDetail?.guideUIProps?.highlightId ?? "";

	const textBlockContainerRef: React.RefObject<HTMLDivElement> =
		React.createRef();
	const subjectBlockContainerRef: React.RefObject<HTMLDivElement> =
		React.createRef();
	const recipientRef: React.RefObject<HTMLDivElement> = React.createRef();

	const [emailThreadMessageFiles, setEmailThreadMessageFiles] = useState<
		string[]
	>(props.templateAttachments?.map(file => file.file_id) ?? []);
	const [
		emailThreadMessageEditorLoading,
		setEmailThreadMessageEditorLoading
	] = useState(true);
	const [
		emailThreadMessageFileUploading,
		setEmailThreadMessageFileUploading
	] = useState(false);
	const [showCcRecipients, setShowCcRecipients] = useState(false);
	const [showBccRecipients, setShowBccRecipients] = useState(false);
	const [mergeTagDropdownX, setMergeTagDropdownX] = useState(0);
	const [mergeTagDropdownY, setMergeTagDropdownY] = useState(0);
	const [mergeTagDropdownVisible, setMergeTagDropdownVisible] =
		useState(false);
	const [isPreviewEmailModalOpen, setIsPreviewEmailModalOpen] =
		useState(false);
	const [isPreviewLoading, setIsPreviewLoading] = useState(false);
	const [isEmptyMergeTagsAlertModalOpen, setIsEmptyMergeTagsAlertModalOpen] =
		useState(false);
	const [emptyMergeTagsState, setEmptyMergeTags] = useState<Array<string>>(
		[]
	);
	const [
		isEmptyMergeTagsAlertFromSendEmail,
		setIsEmptyMergeTagsAlertFromSendEmail
	] = useState(false);
	const [shouldReplaceWithBlankState, setShouldReplaceWithBlank] =
		useState(true);
	const [isImportEmailTemplateModalOpen, setIsImportEmailTemplateModalOpen] =
		useState(false);
	const [
		shouldEmptyMergeTagAlertOpenFromSend,
		setShouldEmptyMergeTagAlertOpenFromSend
	] = useState(true);
	const [isValidating, setIsValidating] = useState(false);
	const [emailTracking, setEmailTracking] = useState<EmailTracking | null>(
		movePreferencesToGlobal
			? userCompany.settings.preference_settings
					?.email_tracking_preference_settings ?? null
			: userData?.user_settings?.preference_settings
					?.email_tracking_preference_settings ?? null
	);
	const [isLoadingState, setIsLoading] = useState(false);
	const [systemSendEmailTemplate, setSystemSendEmailTemplate] =
		useState<EmailTemplate | null>(null);
	const [emailSent, setEmailSent] = useState(false);
	const [isMandatoryMergeTagModalOpen, setIsMandatoryMergeTagModalOpen] =
		useState(false);
	const [currentActiveEmailSignature, setCurrentActiveEmailSignature] =
		useState<EmailSignature | null>(null);
	const [dkimConnectedEmails, setDkimConnectedEmails] = useState<
		ConnectedEmails[]
	>([]);
	const [emailExpiredModalVisible, setEmailExpiredModalVisible] =
		useState(false);
	const [emailExpiredMessage, setEmailExpiredMessage] = useState<string>("");
	const [listOfAttachments, setListOfAttachments] = useState<
		UploadFile<any>[]
	>(
		props.templateAttachments?.map(
			file =>
				({
					uid: file.file_id,
					name: file.file_name,
					status: FileUploadStatus.DONE,
					size: file.file_size ?? 0
				} as UploadFile<any>)
		) ?? []
	);

	const [recipientSearch, setRecipientSearch] = useState<string>("");
	const [shouldCollapse, setShouldCollapse] = useState(true);

	const dispatch = useDispatch();
	const sendMs365InviteToClientStopDispatch = () =>
		dispatch(EmailThreadActionCreators.sendMs365InviteToClientStop());
	const validateEmailMergeTagsDispatch = (
		validateEmailMergeTagsRequest: ValidateEmailMergeTagsRequest
	) =>
		dispatch(
			EmailThreadActionCreators.validateEmailMergeTags(
				validateEmailMergeTagsRequest
			)
		);

	useEffect(() => {
		extractValidDkimData();
	}, []);

	const extractValidDkimData = () => {
		const connected_email: ConnectedEmails[] = [];
		userCompany?.settings?.dkim_verification?.domain?.map(domain => {
			if (domain.status === "success") {
				domain.connected_emails?.map(email => {
					if (email.status === "success") connected_email.push(email);
					return;
				});
			}
			return;
		});
		userCompany?.settings?.dkim_verification?.email?.map(email => {
			if (email.status === "success") {
				const modifiedData = {
					...email,
					name: email.name ?? email.email
				};
				connected_email.push(modifiedData);
			}
			return;
		});
		setDkimConnectedEmails(connected_email);
	};

	useComponentDidUpdate(() => {
		if (mergeTagDropdownVisible) {
			setMergeTagDropdownVisible(false);
		}
		if (props.visible) {
			const { documentId, opportunityId, clientId, purchaseOrderId } =
				props;
			dispatch(
				EmailThreadActionCreators.fetchMergeTags(
					new FetchMergeTagsRequest({
						documentId,
						opportunityId,
						clientId,
						purchaseOrderId
					})
				)
			);

			document.addEventListener("click", handleCollapse);

			const defaultEmailSignature =
				emailSignatures.signatures.find(
					signature => signature.is_default
				) ?? null;

			setCurrentActiveEmailSignature(defaultEmailSignature);
			fetchAllEmailSignatures();

			if (props.isFromEmailTemplatesPage) {
				setEmailThreadMessageFiles(
					props.templateAttachments?.map(file => file.file_id) ?? []
				);
				setListOfAttachments(
					props.templateAttachments?.map(
						file =>
							({
								uid: file.file_id,
								name: file.file_name,
								status: FileUploadStatus.DONE,
								size: file.file_size ?? 0
							} as UploadFile<any>)
					) ?? []
				);
			}

			if (!!props?.clientId?.length || !!props?.opportunityId?.length) {
				appendSignatureInEditor();
			}
			if (props.templateAttachments) {
				setEmailThreadMessageFiles(
					props.templateAttachments?.map(file => file.file_id) ?? []
				);
				setListOfAttachments(
					props.templateAttachments?.map(
						file =>
							({
								uid: file.file_id,
								name: file.file_name,
								status: FileUploadStatus.DONE,
								size: file.file_size ?? 0
							} as UploadFile<any>)
					) ?? []
				);
			}
			setTimeout(() => {
				if (isSendDocumentEmailGuideActive) {
					handleGuideVisiblity?.(true);
				}
			}, 1000);
		} else {
			document.removeEventListener("click", handleCollapse);
		}
	}, [props.visible]);

	const appendSignatureInEditor = () => {
		const emailThreadMessageEditorElement = window.tinyMCE?.get(
			props.isNewThread
				? EmailThreadMessageEditorType.Compose
				: EmailThreadMessageEditorType.Reply
		);
		if (!emailThreadMessageEditorElement) {
			console.warn(" Tiny mce editor not ready");
			return;
		}
		const content = emailThreadMessageEditorElement.getContent({
			format: "raw"
		});
		const defaultEmailSignature =
			emailSignatures.signatures.find(
				signature => signature.is_default
			) ?? null;
		if (defaultEmailSignature) {
			emailThreadMessageEditorElement.setContent(
				content + defaultEmailSignature.body
			);
		}
	};

	const setEmailBody = (systemSendEmailTemplate: EmailTemplate) => {
		const emailThreadMessageEditorElement = window?.tinyMCE?.get(
			props.isNewThread
				? EmailThreadMessageEditorType.Compose
				: EmailThreadMessageEditorType.Reply
		);
		const editorContent = updateMergeTagsDisplayName(
			systemSendEmailTemplate.merge_tags_system_variables,
			systemSendEmailTemplate?.body
		);
		if (emailThreadMessageEditorElement && editorContent) {
			emailThreadMessageEditorElement.setContent(editorContent);
		} else {
			console.warn("Tiny mce editor not ready");
			return;
		}
	};

	const setEmailSubject = (systemSendEmailTemplate: EmailTemplate) => {
		const convertedTextToMergeTags = convertTextToMergeTag(
			systemSendEmailTemplate?.merge_tags_system_variables,
			systemSendEmailTemplate?.subject,
			true
		);
		const emailThreadMessageSubjectElement = window?.tinyMCE?.get(
			`${
				props.isNewThread
					? EmailThreadMessageEditorType.Compose
					: EmailThreadMessageEditorType.Reply
			}-subject`
		);
		const subjectContent = updateMergeTagsDisplayName(
			systemSendEmailTemplate?.merge_tags_system_variables,
			convertedTextToMergeTags
		);
		if (emailThreadMessageSubjectElement && subjectContent) {
			emailThreadMessageSubjectElement.setContent(subjectContent);
		} else {
			console.warn("Tiny mce subject editor not ready");
			return;
		}
	};

	const fetchSystemSendEmailTemplate = async () => {
		try {
			setIsLoading(true);
			const response = await dispatch(
				EmailTemplatesActionCreators.fetchTemplateByType(
					CustomTemplateType.SendDocument
				)
			);
			const sendDocTemplate = response.templates.find(
				(template: EmailTemplate) =>
					template.custom_template_type ===
					CustomTemplateType.SendDocument
			);
			if (!!sendDocTemplate) {
				setEmailSubject(sendDocTemplate);
			}
			if (
				!sendDocTemplate ||
				!!sendDocTemplate?.system_template_info ||
				!props.isNewThread
			) {
				return;
			}
			setEmailBody(sendDocTemplate);
			setSystemSendEmailTemplate(sendDocTemplate);
			setEmailThreadMessageFiles(
				sendDocTemplate?.file_details?.map(file => file.file_id) ?? []
			);
			setListOfAttachments(
				sendDocTemplate?.file_details?.map(
					file =>
						({
							uid: file.file_id,
							name: file.file_name,
							status: FileUploadStatus.DONE,
							size: file.file_size ?? 0
						} as UploadFile)
				) ?? []
			);
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const resetState = () => {
		setEmailThreadMessageFiles(new Array<string>());
		setListOfAttachments(new Array<UploadFile<any>>());
		setEmailThreadMessageEditorLoading(false);
		setEmailThreadMessageFileUploading(false);
		setShowCcRecipients(false);
		setShowBccRecipients(false);
	};

	const initializeEmailThreadMessageDrawerEditor = () => {
		setEmailThreadMessageEditorLoading(false);
	};

	const onClose = () => {
		if (!mergeTagDropdownVisible) {
			resetState();
			sendMs365InviteToClientStopDispatch();
			if (props.onClose) {
				setSystemSendEmailTemplate(null);
				dispatch(EmailThreadActionCreators.resetMergeTags());
				props.onClose();
				emailSent &&
					props.refreshSalesActivities &&
					props.refreshSalesActivities(false);
				setEmailSent(false);
			}
		} else {
			setMergeTagDropdownVisible(false);
		}
		dispatch(SettingsActionCreators.resetFormEdited(FormKeys.SendEmail));
	};

	const handleCancel = () => {
		if (!isFormEdited?.[FormKeys.SendEmail]) {
			onClose();
		} else {
			ZModalConfirm({
				content: "Are you sure you want to discard this email?",
				onOk: onClose
			});
		}
	};

	const toggleCcRecipients = () => {
		setShowCcRecipients(!showCcRecipients);
	};

	const toggleBccRecipients = () => {
		setShowBccRecipients(!showBccRecipients);
	};

	const previewDocument = () => {
		if (
			props.isDocumentMessage &&
			props.documentId &&
			props.documentId.length > 0
		) {
			window.open(
				`${ZomentumRoutes.DocumentsPreview.replace(
					":id",
					props.documentId
				)}`
			);
		} else {
			ZMessage.error(DefaultErrorMessage);
		}
	};

	const beforeUploadEmailThreadFile = (file: RcFile, _fileList: RcFile[]) => {
		const totalSizeOfAttachments = listOfAttachments.reduce(
			(sum, attachment) => (attachment.size as number) + sum,
			0
		);
		const isFileSizeLessThan25MB =
			totalSizeOfAttachments + file.size < 25 * 1024 * 1024;
		const isFileSizeLessThan7MB =
			totalSizeOfAttachments + file.size < 7 * 1024 * 1024;
		const isSendingEmailFromDocumentPage =
			props.isDocumentMessage && !!props.isFromDocumentsPage;
		if (!isFileSizeLessThan7MB && isSendingEmailFromDocumentPage) {
			ZMessage.error(
				"Error: Total size of attachments exceeds maximum allowed size of 7 MB"
			);
			return isFileSizeLessThan7MB;
		}
		if (!isFileSizeLessThan25MB) {
			ZMessage.error(
				"Error: Total size of attachments exceeds maximum allowed size of 25 MB"
			);
		}
		return isFileSizeLessThan25MB;
	};

	const uploadEmailThreadFile = (
		info: UploadChangeParam<UploadFile<EmailThreadFile>>
	) => {
		try {
			setListOfAttachments([...info.fileList]);
			if (info.file.status === FileUploadStatus.DONE) {
				const uploadEmailThreadFileResponse = info.file.response;
				if (
					(uploadEmailThreadFileResponse &&
						uploadEmailThreadFileResponse.id &&
						uploadEmailThreadFileResponse.id.length > 0) ||
					(uploadEmailThreadFileResponse &&
						uploadEmailThreadFileResponse.file_id)
				) {
					let temp = "";
					if (uploadEmailThreadFileResponse.id) {
						temp = uploadEmailThreadFileResponse.id;
					} else if (uploadEmailThreadFileResponse.file_id) {
						temp = uploadEmailThreadFileResponse.file_id;
					}
					setEmailThreadMessageFiles(
						emailThreadMessageFiles.concat(temp)
					);
					setEmailThreadMessageFileUploading(false);
					ZMessage.success(
						`${info.file.name} file uploaded successfully`
					);
				} else {
					ZMessage.error(`${info.file.name} file upload failed.`);
					setEmailThreadMessageFileUploading(false);
				}
			} else if (info.file.status === FileUploadStatus.REMOVED) {
				const newListOfAttachments = listOfAttachments.filter(
					attachment => attachment.status !== FileUploadStatus.REMOVED
				);
				setListOfAttachments(newListOfAttachments);
				setEmailThreadMessageFileUploading(false);
			} else if (info.file.status === FileUploadStatus.ERROR) {
				ZMessage.error(`${info.file.name} file upload failed.`);
				const newListOfAttachments = listOfAttachments.filter(
					attachment => attachment.status !== FileUploadStatus.ERROR
				);
				setListOfAttachments(newListOfAttachments);
				setEmailThreadMessageFileUploading(false);
			} else if (info.file.status === undefined) {
				const newListOfAttachments = listOfAttachments.filter(
					attachment => attachment.status
				);
				setListOfAttachments(newListOfAttachments);
				setEmailThreadMessageFileUploading(false);
			} else {
				setEmailThreadMessageFileUploading(true);
			}
		} catch (error) {
			console.error(error);
			setEmailThreadMessageFileUploading(false);
		}
	};

	const deleteEmailThreadFile = (file: UploadFile) => {
		try {
			if (file.status === FileUploadStatus.ERROR) {
				throw new Error(`${file.name} file deletion failed.`);
			}
			let comparison: string;
			if (!!file.response?.id) {
				comparison = file.response.id;
			} else if (!!file.response?.file_id) {
				comparison = file.response.file_id;
			} else {
				comparison = file.uid;
			}
			setEmailThreadMessageFiles(
				emailThreadMessageFiles.filter(
					emailThreadMessageFile =>
						emailThreadMessageFile !== comparison
				)
			);
			ZMessage.success(`${file.name} file removed successfully`);
		} catch (error) {
			console.error(error);
		}
	};

	const getFormValuesForEmail = (
		sendEmailThreadMessageFormValues: SendEmailThreadMessageFormValues,
		useDefaultEmail?: boolean
	) => {
		try {
			const isTinyReady =
				process.env.REACT_APP_TINY_MCE &&
				process.env.REACT_APP_TINY_MCE.length > 0 &&
				props.emailThreadMessage &&
				window.tinyMCE &&
				window.tinyMCE.get;

			if (!isTinyReady) {
				console.warn("Tiny not ready");
				return null;
			}
			const emailThreadMessageEditorElement = window.tinyMCE.get(
				props.isNewThread
					? EmailThreadMessageEditorType.Compose
					: EmailThreadMessageEditorType.Reply
			);

			if (!emailThreadMessageEditorElement) {
				console.warn("Editor body not ready");
				return null;
			}

			const emailThreadMessageSubjectElement = window.tinyMCE.get(
				`${
					props.isNewThread
						? EmailThreadMessageEditorType.Compose
						: EmailThreadMessageEditorType.Reply
				}-subject`
			);

			if (!emailThreadMessageSubjectElement && props.isNewThread) {
				console.warn("Subject editor not ready");
				return null;
			}

			const alias = userEmailIntegrationObj?.email_aliases?.find(
				data => data.email === sendEmailThreadMessageFormValues.from
			);

			const dkim = dkimConnectedEmails?.find(
				data => data.email === sendEmailThreadMessageFormValues.from
			);

			const isNylasEmailID =
				sendEmailThreadMessageFormValues.from?.includes(
					nylasConnectedEmailSuffix
				);

			/**
			 *
			 *  Checks alias and dkim to setup "from" value,
			 *  also checks if the from email is default zomentum's email then it sets to undefined else if the email isn't verified it'll set to null.
			 *  * Make sure to check type of "from" cause undefined and null has different means in our context
			 *
			 */
			let from: EmailThreadRecipients | null | undefined;

			if (isNylasEmailID) {
				from = {
					email: formatNylasIntegratedEmailId(
						sendEmailThreadMessageFormValues.from,
						true
					),
					name: userData.name.full,
					id: userData.id,
					is_nylas: true
				};
			} else if (alias) {
				from = {
					email: alias.email,
					name: alias.name,
					id: userData.id
				};
			} else if (useDefaultEmail) {
				from = {
					...defaultFromValues
				};
			} else if (dkim) {
				from = {
					email: dkim.email,
					name: dkim.name,
					id: userData.id
				};
			} else if (
				sendEmailThreadMessageFormValues.from ===
				process.env.REACT_APP_DEFAULT_EMAIL
			) {
				from = undefined;
			} else if (sendEmailThreadMessageFormValues.from) {
				from = {
					email: sendEmailThreadMessageFormValues.from,
					name: userData.name.full,
					id: userData.id
				};
			}

			const emailBody: string =
				emailThreadMessageEditorElement.getContent();
			const emailSubject: string =
				!props.isNewThread && props.emailThreadMessage
					? props.emailThreadMessage?.subject
					: emailThreadMessageSubjectElement.targetElm.innerText;

			const mapRecepientIdAndEmail = (idOrEmail: string) => {
				const recipient = props.allEmailRecipients?.find(
					user => user.id === idOrEmail
				);
				if (recipient) {
					const emailThreadRecipient = new EmailThreadRecipients();
					emailThreadRecipient.email = recipient.email;
					emailThreadRecipient.name = recipient.name;
					emailThreadRecipient.id = recipient.id;
					return emailThreadRecipient;
				} else {
					const emailThreadRecipient = new EmailThreadRecipients();
					emailThreadRecipient.email = idOrEmail;
					return emailThreadRecipient;
				}
			};

			const recipients =
				sendEmailThreadMessageFormValues?.to?.map(
					mapRecepientIdAndEmail
				) ?? new Array<EmailThreadRecipients>();

			const cc =
				sendEmailThreadMessageFormValues?.cc?.map(
					mapRecepientIdAndEmail
				) ?? new Array<EmailThreadRecipients>();

			const bcc =
				sendEmailThreadMessageFormValues?.bcc?.map(
					mapRecepientIdAndEmail
				) ?? new Array<EmailThreadRecipients>();

			const file_ids = [...emailThreadMessageFiles];

			const account_id = props.emailThreadMessage?.account_id;

			const areAllThreeEntitiesAreSelected =
				props.documentId && props.clientId && props.opportunityId;
			const areClientAndDocumentSelected =
				props.documentId && props.clientId;
			const areClientAndOpportunitySelected =
				props.clientId && props.opportunityId;

			let currentMail_id = "";
			let currentMail_type: EntityType = EntityType.Client;

			if (props.isNewThread) {
				if (
					areAllThreeEntitiesAreSelected ||
					areClientAndDocumentSelected
				) {
					currentMail_id = props.documentId || "";
					currentMail_type = EntityType.Document;
				} else if (areClientAndOpportunitySelected) {
					currentMail_id = props.opportunityId || "";
					currentMail_type = EntityType.Opportunity;
				} else if (!!props.clientId) {
					currentMail_id = props.clientId || "";
					currentMail_type = EntityType.Client;
				} else if (!!props.documentId) {
					currentMail_id = props.documentId || "";
					currentMail_type = EntityType.Document;
				} else if (!!props.purchaseOrderId) {
					currentMail_id = props.purchaseOrderId || "";
					currentMail_type = EntityType.PurchaseOrder;
				} else {
					currentMail_id = props.opportunityId || "";
					currentMail_type = EntityType.Opportunity;
				}
			} else {
				if (!!props.clientId) {
					currentMail_id = props.clientId || "";
					currentMail_type = EntityType.Client;
				} else if (!!props.opportunityId) {
					currentMail_id = props.opportunityId || "";
					currentMail_type = EntityType.Opportunity;
				} else {
					currentMail_id = "";
					currentMail_type = EntityType.Client;
				}
			}

			return {
				from,
				recipients,
				cc,
				bcc,
				file_ids,
				emailBody,
				emailSubject,
				account_id,
				currentMail_id,
				currentMail_type
			};
		} catch (error) {
			ZMessage.error(DefaultErrorMessage);
			console.error(error);
			return;
		}
	};

	const generateDocumentEmailPreview = async (
		documentEmailPreviewRequest: GetDocumentEmailPreviewRequest
	) => {
		setIsPreviewLoading(true);
		try {
			await dispatch(
				EmailThreadActionCreators.previewDocumentEmail(
					documentEmailPreviewRequest
				)
			);
		} catch (error) {
			ZMessage.error(DefaultErrorMessage);
			console.error(error);
		} finally {
			setIsPreviewLoading(false);
		}
	};

	const generateOtherEntityPreview = async (
		previewEmailRequest: Partial<GetEmailPreviewRequest>
	) => {
		setIsPreviewLoading(true);
		try {
			await dispatch(
				EmailThreadActionCreators.previewEmail(previewEmailRequest)
			);
		} catch (error) {
			setIsPreviewEmailModalOpen(false);
			ZMessage.error(DefaultErrorMessage);
			console.error(error);
		} finally {
			setIsPreviewLoading(false);
		}
	};

	const fetchAllEmailSignatures = () => {
		setIsPreviewLoading(true);
		try {
			dispatch(UsersActionCreators.fetchAllEmailSignatures());
		} catch (error) {
			console.error(error);
		} finally {
			setIsPreviewLoading(false);
		}
	};

	const verifyAndOpenPreviewModal = () => {
		props.form.validateFields(
			async (
				errors: unknown,
				sendEmailThreadMessageFormValues: SendEmailThreadMessageFormValues
			) => {
				if (!errors) {
					try {
						const formValues = getFormValuesForEmail(
							sendEmailThreadMessageFormValues
						);

						if (!formValues) {
							console.warn("No form values found");
							return;
						}

						const validateEmailMergeTagsRequest =
							new ValidateEmailMergeTagsRequest();

						validateEmailMergeTagsRequest.from =
							formValues?.from ?? defaultFromValues;
						validateEmailMergeTagsRequest.to =
							formValues.recipients;
						validateEmailMergeTagsRequest.cc = formValues.cc;
						validateEmailMergeTagsRequest.bcc = formValues.bcc;
						validateEmailMergeTagsRequest.body =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailBody
							);
						validateEmailMergeTagsRequest.subject =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailSubject
							);
						validateEmailMergeTagsRequest.mail_type =
							formValues.currentMail_type;
						validateEmailMergeTagsRequest.mail_id =
							formValues.currentMail_id;

						setIsValidating(true);

						await validateEmailMergeTagsDispatch(
							validateEmailMergeTagsRequest
						);

						setIsValidating(false);

						const emptyMergeTagsValue: string[] =
							emptyMergeTags || [];

						if (!!emptyMergeTags?.length) {
							setEmptyMergeTags(emptyMergeTagsValue);
							setIsEmptyMergeTagsAlertModalOpen(true);
						} else {
							continueToPreviewEmail(MergeTagPreference.REPLACE);
						}
					} catch (error) {
						console.error(error);
					}
				}
			}
		);
	};

	const continueToPreviewEmail = (
		shouldReplaceWithBlank?: MergeTagPreference
	) => {
		props.form.validateFields(
			(
				error,
				sendEmailThreadMessageFormValues: SendEmailThreadMessageFormValues
			) => {
				if (!error) {
					try {
						const formValues = getFormValuesForEmail(
							sendEmailThreadMessageFormValues
						);

						if (!formValues) {
							console.warn("No form values found");
							return;
						}

						const previewEmailRequest =
							new GetEmailPreviewRequest();

						previewEmailRequest.from = formValues?.from || null;
						previewEmailRequest.to = formValues.recipients;
						previewEmailRequest.subject = replaceMergeTagsWithId(
							emailThreadMergeTagVariables,
							formValues.emailSubject
						);
						previewEmailRequest.body = replaceMergeTagsWithId(
							emailThreadMergeTagVariables,
							formValues.emailBody
						);
						previewEmailRequest.should_replace_with_empty_string =
							shouldReplaceWithBlankState;
						previewEmailRequest.mail_id = formValues.currentMail_id;
						previewEmailRequest.mail_type =
							formValues.currentMail_type;
						previewEmailRequest.file_ids = formValues.file_ids;
						previewEmailRequest.signature =
							currentActiveEmailSignature?.body ?? "";

						const documentEmailPreviewRequest =
							new GetDocumentEmailPreviewRequest();

						documentEmailPreviewRequest.to = formValues.recipients;
						documentEmailPreviewRequest.bcc = formValues.bcc;
						documentEmailPreviewRequest.cc = formValues.cc;
						documentEmailPreviewRequest.should_replace_with_empty_string =
							shouldReplaceWithBlankState;
						documentEmailPreviewRequest.body =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailBody
							);
						documentEmailPreviewRequest.subject =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailSubject
							);
						documentEmailPreviewRequest.documentId =
							props.documentId ?? "";

						documentEmailPreviewRequest.signature =
							currentActiveEmailSignature?.body ?? "";
						if (
							props.isFromDocumentsPage &&
							currentActiveDocument &&
							!!currentActiveDocument?.id?.length
						) {
							generateDocumentEmailPreview(
								documentEmailPreviewRequest
							);
						} else {
							generateOtherEntityPreview(previewEmailRequest);
						}
						setIsPreviewEmailModalOpen(true);
						closeEmptyMergeTagsAlertModal();
					} catch (error) {
						ZMessage.error(DefaultErrorMessage);
						console.error(error);
					}
				}
			}
		);
		setShouldReplaceWithBlank(
			shouldReplaceWithBlank === MergeTagPreference.BLANK
		);
	};

	const onSubmit = ($event: React.FormEvent<HTMLFormElement>) => {
		$event.preventDefault();

		setIsEmptyMergeTagsAlertFromSendEmail(true);

		props.form.validateFieldsAndScroll(
			async (
				error,
				sendEmailThreadMessageFormValues: SendEmailThreadMessageFormValues
			) => {
				if (!error) {
					try {
						const formValues = getFormValuesForEmail(
							sendEmailThreadMessageFormValues
						);

						if (!formValues) {
							console.warn("No form values found");
							return;
						}

						if (formValues.from === null) {
							showEmailExpiredModal("");
							return;
						}

						const isDocumentUrlPresent = checkForDocumentUrlPresent(
							formValues.emailBody
						);

						if (
							!!systemSendEmailTemplate &&
							!!systemSendEmailTemplate?.id?.length &&
							!systemSendEmailTemplate.system_template_info &&
							!isDocumentUrlPresent
						) {
							setIsMandatoryMergeTagModalOpen(true);
							return;
						}

						const validateEmailMergeTagsRequest =
							new ValidateEmailMergeTagsRequest();

						validateEmailMergeTagsRequest.from =
							formValues.from ?? defaultFromValues;
						validateEmailMergeTagsRequest.to =
							formValues.recipients;
						validateEmailMergeTagsRequest.cc = formValues.cc;
						validateEmailMergeTagsRequest.bcc = formValues.bcc;
						validateEmailMergeTagsRequest.body =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailBody
							);
						validateEmailMergeTagsRequest.subject =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailSubject
							);
						validateEmailMergeTagsRequest.mail_type =
							formValues.currentMail_type;
						validateEmailMergeTagsRequest.mail_id =
							formValues.currentMail_id;

						const validateTo = validateEmails(
							validateEmailMergeTagsRequest.to
						);
						const validateCc = validateEmails(
							validateEmailMergeTagsRequest.cc
						);
						const validateBcc = validateEmails(
							validateEmailMergeTagsRequest.bcc
						);

						if (!validateTo) {
							ZMessage.error(
								"Invalid email entered in the TO field. Please verify the email address and try again"
							);
							return;
						} else if (!validateCc) {
							ZMessage.error(
								"Invalid email entered in the CC field. Please verify the email address and try again"
							);
							return;
						} else if (!validateBcc) {
							ZMessage.error(
								"Invalid email entered in the BCC field. Please verify the email address and try again"
							);
							return;
						}

						const isEmailBodyValid = checkForValidMergeTag(
							emailThreadMergeTagVariables,
							formValues.emailBody,
							"Receiver"
						);

						const isEmailSubjectValid = checkForValidMergeTag(
							emailThreadMergeTagVariables,
							formValues.emailSubject,
							"Receiver"
						);
						if (
							(isEmailBodyValid || isEmailSubjectValid) &&
							!props.isDocumentMessage &&
							props.hideReceiverMergeTag
						) {
							ZMessage.error(
								"This email includes ‘Receiver Merge Tags’ which will not resolve for the recipients, Please remove them to continue sending email"
							);
							return;
						}

						if (shouldEmptyMergeTagAlertOpenFromSend) {
							setIsValidating(true);
							await validateEmailMergeTagsDispatch(
								validateEmailMergeTagsRequest
							);
							setIsValidating(false);
						}

						const emptyMergeTagsValue: string[] =
							shouldEmptyMergeTagAlertOpenFromSend
								? emptyMergeTags || []
								: [];
						if (
							emptyMergeTagsValue.length > 0 &&
							shouldEmptyMergeTagAlertOpenFromSend
						) {
							setEmptyMergeTags(emptyMergeTagsValue);
							setIsEmptyMergeTagsAlertModalOpen(true);
						} else {
							continueToSendEmail(MergeTagPreference.REPLACE);
						}
					} catch (error) {
						if (!error.message) {
							ZMessage.error(DefaultErrorMessage);
						}
						console.error(error);
					} finally {
						setIsValidating(false);
					}
				}
			}
		);
	};

	const continueToSendEmail = (
		shouldReplaceWithBlank?: MergeTagPreference,
		useDefaultEmail?: boolean
	) => {
		const checkMergeTag =
			shouldReplaceWithBlank !== MergeTagPreference.BLANK ? false : true;

		const shouldReplaceEmpyMergeTagWithBlank =
			shouldEmptyMergeTagAlertOpenFromSend
				? checkMergeTag
				: shouldReplaceWithBlankState;

		props.form.validateFields(
			(
				errors: unknown,
				sendEmailThreadMessageFormValues: SendEmailThreadMessageFormValues
			) => {
				if (!errors) {
					try {
						const formValues = getFormValuesForEmail(
							sendEmailThreadMessageFormValues,
							useDefaultEmail
						);

						if (!formValues) {
							console.warn("No form values found");
							return;
						}

						const sendEmailThreadMessageRequest =
							new SendEmailThreadMessageRequest();

						sendEmailThreadMessageRequest.from =
							formValues.from ?? defaultFromValues;
						sendEmailThreadMessageRequest.to =
							formValues.recipients;
						sendEmailThreadMessageRequest.subject =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues?.emailSubject
							);
						sendEmailThreadMessageRequest.body =
							replaceMergeTagsWithId(
								emailThreadMergeTagVariables,
								formValues.emailBody
							);
						sendEmailThreadMessageRequest.bcc = formValues.bcc;
						sendEmailThreadMessageRequest.cc = formValues.cc;
						sendEmailThreadMessageRequest.mail_type =
							formValues.currentMail_type;
						sendEmailThreadMessageRequest.mail_id =
							formValues.currentMail_id;
						sendEmailThreadMessageRequest.account_id =
							formValues.account_id || "";
						sendEmailThreadMessageRequest.file_ids =
							formValues.file_ids;
						sendEmailThreadMessageRequest.should_replace_with_empty_string =
							shouldReplaceWithBlankState;
						sendEmailThreadMessageRequest.tracking = emailTracking;
						sendEmailThreadMessageRequest.reply_to_message_id =
							props.emailThreadMessage
								? props.emailThreadMessage.message_ids[
										props.emailThreadMessage.message_ids
											.length - 1
								  ]
								: "";
						sendEmailThreadMessageRequest.signature =
							currentActiveEmailSignature?.body ?? "";

						sendEmailThreadMessage(sendEmailThreadMessageRequest);
					} catch (error) {
						console.error(error);
						ZMessage.error(DefaultErrorMessage);
					}
				}
			}
		);
		closeEmptyMergeTagsAlertModal();
		setShouldReplaceWithBlank(shouldReplaceEmpyMergeTagWithBlank);
	};

	const sendEmailThreadMessage = async (
		sendEmailThreadMessageRequest: SendEmailThreadMessageRequest
	) => {
		dispatch(EmailThreadActionCreators.showEmailThreadLoader());
		try {
			if (!props.emailThreadMessage) {
				throw new Error("Email thread message is empty");
			}
			const isSendingEmailFromDocumentPage =
				props.isDocumentMessage && !!props.isFromDocumentsPage;

			if (isSendingEmailFromDocumentPage && !!props?.documentId?.length) {
				const sendDocumentEmailThreadMessageRequest: SendDocumentEmailThreadMessageRequest =
					new SendDocumentEmailThreadMessageRequest();

				sendDocumentEmailThreadMessageRequest.to =
					sendEmailThreadMessageRequest.to;
				sendDocumentEmailThreadMessageRequest.document_id =
					props.documentId;
				sendDocumentEmailThreadMessageRequest.from =
					sendEmailThreadMessageRequest.from ?? defaultFromValues;
				sendDocumentEmailThreadMessageRequest.subject =
					sendEmailThreadMessageRequest?.subject ?? "";
				sendDocumentEmailThreadMessageRequest.body =
					sendEmailThreadMessageRequest.body;
				sendDocumentEmailThreadMessageRequest.signature =
					sendEmailThreadMessageRequest.signature;
				if (!isNewDocumentSendView) {
					sendDocumentEmailThreadMessageRequest.bcc =
						sendEmailThreadMessageRequest.bcc;
					sendDocumentEmailThreadMessageRequest.cc =
						sendEmailThreadMessageRequest.cc;
				}
				sendDocumentEmailThreadMessageRequest.file_ids =
					sendEmailThreadMessageRequest.file_ids;
				sendDocumentEmailThreadMessageRequest.should_replace_with_empty_string =
					sendEmailThreadMessageRequest.should_replace_with_empty_string;

				await props.onBeforeSubmit?.(
					sendDocumentEmailThreadMessageRequest
				);

				await dispatch(
					EmailThreadActionCreators.sendEmailDocumentMessage(
						sendDocumentEmailThreadMessageRequest
					)
				);

				onClose();
				ZMessage.success("Email sent successfully");
				props.onSubmit?.();
				handleSendDocumentEmailNext?.();
			} else if (
				!!props.emailThreadMessage?.account_id?.length &&
				props.emailThreadMessage.account_id ===
					sendEmailThreadMessageRequest.account_id
			) {
				await dispatch(
					EmailThreadActionCreators.sendEmailThreadMessage(
						sendEmailThreadMessageRequest
					)
				);
				setEmailSent(true);
				onClose();
				ZMessage.success("Email sent successfully");
				props.onSubmit?.(sendEmailThreadMessageRequest);
			} else {
				throw new Error("Account id is missing");
			}
		} catch (error) {
			console.error(error);
			const errorRes = error?.message;
			if (
				errorRes?.indexOf(
					"The address you are attempting to send the document from is no longer authorized"
				) !== -1
			) {
				showEmailExpiredModal(errorRes);
			} else {
				if (error.error?.response?.data?.message) {
					const errorMessage =
						error.error.response.data.message +
						". " +
						error.displayMessage;
					console.error(errorMessage, error);
				} else {
					ZMessage.error(DefaultErrorMessage);
				}
			}
		} finally {
			const isLastUsedEmail =
				sendEmailThreadMessageRequest.from?.email ===
				userData.document_last_used_from_address;
			if (!isLastUsedEmail)
				await dispatch(UsersActionCreators.getUserData());
			dispatch(EmailThreadActionCreators.hideEmailThreadLoader());
		}
	};

	const showEmailExpiredModal = (errorRes: string) => {
		setEmailExpiredModalVisible(true);
		setEmailExpiredMessage(errorRes);
	};

	const closeEmailExpiredModal = () => {
		setEmailExpiredModalVisible(false);
		setEmailExpiredMessage("");
	};

	const handleEmailExpiration = () => {
		const emptyMergeTagsValue: string[] =
			shouldEmptyMergeTagAlertOpenFromSend ? emptyMergeTags || [] : [];
		if (emptyMergeTagsValue?.length) {
			setEmptyMergeTags(emptyMergeTagsValue);
			setIsEmptyMergeTagsAlertModalOpen(true);
		} else {
			continueToSendEmail(MergeTagPreference.REPLACE, true);
		}
		closeEmailExpiredModal();
	};

	const closeMandatoryMergeTagModal = () => {
		setIsMandatoryMergeTagModalOpen(false);
	};

	const setMergeTagDropdownVisibleHandle = (isVisible: boolean) => {
		setMergeTagDropdownVisible(isVisible);
	};

	const closeEmptyMergeTagsAlertModal = () => {
		setEmptyMergeTags([]);
		setIsEmptyMergeTagsAlertModalOpen(false);
		setIsEmptyMergeTagsAlertFromSendEmail(false);
		dispatch(EmailThreadActionCreators.resetEmptyMergeTags());
	};

	const closePreviewModal = () => {
		dispatch(EmailThreadActionCreators.resetDocumentEmailPreview());
		dispatch(EmailThreadActionCreators.resetEmailPreview());
		dispatch(EmailThreadActionCreators.resetMs365ConsentEmailPreview());
		setIsPreviewEmailModalOpen(false);
		setShouldEmptyMergeTagAlertOpenFromSend(false);
	};

	const handleSubmitMergeTagVariable = (key: string) => {
		setMergeTagDropdownVisibleHandle(false);
		window.requestAnimationFrame(() => {
			window.tinyMCE.activeEditor.focus();
			mergeTagDropDownOnSubmit(key);
		});
	};

	const updateTextFromEmailBodyTinyMCEEditor = () => {
		setMergeTagDropdownVisible(false);
		setShouldEmptyMergeTagAlertOpenFromSend(true);

		if (window.tinyMCE.activeEditor.selection) {
			const boundingClientRect =
				window.tinyMCE.activeEditor.selection.getBoundingClientRect();
			if (
				boundingClientRect &&
				textBlockContainerRef &&
				textBlockContainerRef.current
			) {
				const parentRect = window.tinyMCE.activeEditor
					.getContentAreaContainer()
					.getBoundingClientRect();
				setMergeTagDropdownX(boundingClientRect.right);
				setMergeTagDropdownY(boundingClientRect.bottom + parentRect.y);
			}
			checkForMergeTagStart();
		}
	};

	const updateTextFromSubjectTinyMCEEditor = () => {
		setMergeTagDropdownVisible(false);
		setShouldEmptyMergeTagAlertOpenFromSend(true);

		if (window.tinyMCE.activeEditor.selection) {
			const boundingClientRect =
				window.tinyMCE.activeEditor.selection.getBoundingClientRect();
			if (
				boundingClientRect &&
				subjectBlockContainerRef &&
				subjectBlockContainerRef.current
			) {
				const parentRect =
					subjectBlockContainerRef.current?.getBoundingClientRect();

				setMergeTagDropdownX(boundingClientRect.right - parentRect.x);
				setMergeTagDropdownY(boundingClientRect.bottom);
			}
			checkForMergeTagStart();
		}
	};

	const checkForMergeTagStart = () => {
		const currentRange = window.tinyMCE.activeEditor.selection.getRng(
			window.tinyMCE.activeEditor.selection.getNode()
		);
		if (
			currentRange &&
			currentRange.startContainer.textContent
				.substr(0, currentRange.startOffset)
				.endsWith(MERGE_TAG_START)
		) {
			window.requestAnimationFrame(() => {
				setMergeTagDropdownVisible(true);
			});
		}
	};

	const mergeTagDropDownOnSubmit = (key: string) => {
		const editorRange = window.tinyMCE.activeEditor.selection.getRng();
		const node = editorRange.commonAncestorContainer;
		const newRange = document.createRange();
		newRange.selectNodeContents(node);
		newRange.setStart(node, editorRange.endOffset - MERGE_TAG_START.length);
		newRange.setEnd(node, editorRange.endOffset);
		newRange.deleteContents();
		window.tinyMCE.activeEditor.focus();

		const mergeTagDisplayName = emailThreadMergeTagVariables.find(
			mergeTag => mergeTag.variable_name === key
		)?.display_name;

		window.tinyMCE.activeEditor.insertContent(
			`<span class="merge-tag mceNonEditable" contentEditable="false" data-mce-contenteditable="false" data-id=${key}>${MERGE_TAG_START}${mergeTagDisplayName}${MERGE_TAG_END}</span>\ufeff `,
			{
				format: "html"
			}
		);

		setMergeTagDropdownVisible(false);
	};

	const handleCloseMergeTagDropdown = () => {
		setMergeTagDropdownVisibleHandle(false);
		window.requestAnimationFrame(() => {
			window.tinyMCE.activeEditor.focus();
		});
	};

	const showImportEmailTemplateModal = () => {
		setIsImportEmailTemplateModalOpen(true);
	};

	const closeImportEmailTemplateModal = () => {
		setIsImportEmailTemplateModalOpen(false);
	};

	const handleSelectEmailTemplate = (template: EmailTemplate) => {
		const emailThreadMessageEditorElement = window?.tinyMCE?.get(
			props.isNewThread
				? EmailThreadMessageEditorType.Compose
				: EmailThreadMessageEditorType.Reply
		);

		const emailThreadMessageSubjectElement = window?.tinyMCE?.get(
			`${
				props.isNewThread
					? EmailThreadMessageEditorType.Compose
					: EmailThreadMessageEditorType.Reply
			}-subject`
		);

		closeImportEmailTemplateModal();

		if (!emailThreadMessageEditorElement) {
			console.warn(" Tiny mce editor not ready");
			return;
		}

		const content = emailThreadMessageEditorElement.getContent({
			format: "raw"
		});
		const domParser = new DOMParser();
		const emailEditorContent = domParser.parseFromString(
			content,
			"text/html"
		);
		const signature = emailEditorContent.querySelector(
			"div[data-email-signature][data-valid-signature=true]"
		) as HTMLElement;
		const signatureData = signature
			? `<div data-email-signature=${signature.dataset.emailSignature} data-valid-signature=true>${signature.innerHTML}</div>`
			: "";

		const updatedEditorText: string =
			updateMergeTagsDisplayName(
				emailThreadMergeTagVariables,
				template.body
			) + signatureData;

		emailThreadMessageEditorElement.setContent(updatedEditorText);

		if (!props.isNewThread) {
			return;
		}
		if (!emailThreadMessageSubjectElement) {
			console.warn("Tiny mce subject editor not ready");
			return;
		}

		const convertedTextToMergeTags = convertTextToMergeTag(
			emailThreadMergeTagVariables,
			template?.subject
		);
		setEmailThreadMessageFiles(
			template?.file_details?.map(file => file.file_id) ?? []
		);
		setListOfAttachments(
			template?.file_details?.map(
				file =>
					({
						uid: file.file_id,
						name: file.file_name,
						status: FileUploadStatus.DONE,
						size: file.file_size ?? 0
					} as UploadFile)
			) ?? []
		);

		emailThreadMessageSubjectElement.setContent(
			updateMergeTagsDisplayName(
				emailThreadMergeTagVariables,
				convertedTextToMergeTags
			)
		);
	};
	const updateEmailTrackingDetails = (trackDetails: EmailTracking) => {
		const emailTrackingDetails = Object.keys(trackDetails).some(
			k => (trackDetails as unknown as Record<string, string>)[k]
		)
			? trackDetails
			: null;
		setEmailTracking(emailTrackingDetails);
	};

	const handleCurrentActiveEmailSignature = (
		selectedSignature: EmailSignature | null
	) => {
		setCurrentActiveEmailSignature(selectedSignature);
	};

	const validateEmails = (emails: EmailThreadParticipant[]) => {
		return emails.every(email => email?.email?.match(emailRegex));
	};

	const getDefaultEmailPreference = () => {
		let defaultEmail: string | null | undefined = null;
		const documentPreferenceSettings =
			userData?.user_settings?.preference_settings
				?.document_preference_settings;
		const userEmailIntegrationObj = userCompany.integrations?.email?.find(
			e => e.user_id === userData.id
		);

		if (documentPreferenceSettings && props.isFromDocumentsPage) {
			const isDefaultFromAddress =
				documentPreferenceSettings.default_from_address &&
				(!documentPreferenceSettings.default_from_address_type ||
					documentPreferenceSettings.default_from_address_type ===
						DocumentDefaultPreferenceLastUsedEmail.FIXED_ADDRESS_TYPE);

			const isLastUsedFromAddress =
				!documentPreferenceSettings.default_from_address &&
				documentPreferenceSettings.default_from_address_type ===
					DocumentDefaultPreferenceLastUsedEmail.LAST_USED_ADDRESS_TYPE;

			// default from address
			if (isDefaultFromAddress) {
				defaultEmail = documentPreferenceSettings.default_from_address;
			}

			// last used address type
			if (isLastUsedFromAddress) {
				defaultEmail = userData.document_last_used_from_address;
			}

			if (
				sendDocUsingNylasFlag &&
				userEmailIntegrationObj &&
				documentPreferenceSettings?.is_nylas === true
			) {
				defaultEmail = formatNylasIntegratedEmailId(
					userEmailIntegrationObj.email
				);
			}
		} else if (dkimConnectedEmails.length > 0) {
			if (userEmailIntegrationObj?.email) {
				const integratedEmail = dkimConnectedEmails.find(
					email => email.email === userEmailIntegrationObj?.email
				);
				if (integratedEmail) defaultEmail = integratedEmail.email;
			}
		}

		if (!defaultEmail) {
			if (
				props.opportunityId ||
				props.clientId ||
				props.purchaseOrderId
			) {
				if (userEmailIntegrationObj?.email) {
					return userEmailIntegrationObj?.email;
					// if email is not connected
				} else {
					defaultEmail = process.env.REACT_APP_DEFAULT_EMAIL;
				}
			} else {
				defaultEmail = process.env.REACT_APP_DEFAULT_EMAIL;
			}
		}

		return defaultEmail;
	};

	const handleRecipientSearchStringChange = (value: string) => {
		setRecipientSearch(value);
	};

	const handleSelect = (_value: string) => {
		setRecipientSearch("");
	};

	const handleEmailValidation = (
		values: string[],
		emailType: EmailRecipientsTypes
	) => {
		try {
			if (!values.length) {
				if (emailType === EmailRecipientsTypes.TO) {
					throw new Error("Please add recipients");
				} else if (
					emailType === EmailRecipientsTypes.CC ||
					emailType === EmailRecipientsTypes.BCC
				) {
					throw new Error(
						`Please add ${emailType.toUpperCase()} recipients`
					);
				}
			}
			const allRecipientsIds =
				props.allEmailRecipients?.map(recipient => recipient.id) || [];
			const isAllEmailsValid = values.every(
				email =>
					allRecipientsIds.includes(email) || email.match(emailRegex)
			);
			if (isAllEmailsValid) return Promise.resolve();
			throw new Error(`Invalid email`);
		} catch (err) {
			return Promise.reject(err);
		}
	};

	const handleCollapse = (event: MouseEvent) => {
		if (!props.isFromDocumentsPage) {
			return;
		}
		if (recipientRef.current?.contains(event.target as HTMLElement)) {
			setShouldCollapse(false);
		} else {
			setShouldCollapse(true);
		}
	};

	const getRecipientOptions = (): IOptionProps[] => {
		const inactiveUserIds = companyUserList
			.filter(user => user.is_disabled)
			.map(user => user.id);

		let list = props.allEmailRecipients;

		if (isSendDocumentEmailGuideActive) {
			list = list?.filter(recipient => recipient.id === userData.id);
		}

		return (
			list?.map((recipient, index) => ({
				name: `${recipient.name} <${recipient.email ?? "No Email"}> ${
					inactiveUserIds.includes(recipient.id)
						? "(Inactive User)"
						: ""
				}`,
				value: recipient.id,
				disabled: !recipient.email && !isNewDocumentSendView,
				key: index
			})) ?? []
		);
	};

	const emailPreviewContent = () => {
		if (
			props.isDocumentMessage &&
			currentActiveDocument &&
			!!currentActiveDocument?.id?.length
		) {
			return (
				<Spin spinning={isPreviewLoading}>
					{emailPreview ? <IFRAME content={emailPreview} /> : <div />}
				</Spin>
			);
		} else {
			return (
				<Spin spinning={isPreviewLoading}>
					<div
						className="preview-email-subject"
						dangerouslySetInnerHTML={{
							__html: otherEntityEmailPreview?.subject || ""
						}}
					/>
					<IFRAME content={otherEntityEmailPreview?.body || ""} />
				</Spin>
			);
		}
	};

	const handleFormChange = () => {
		!isFormEdited?.[FormKeys.SendEmail] &&
			dispatch(SettingsActionCreators.setFormEdited(FormKeys.SendEmail));
	};

	const debounceHandleFormChange = debounce(() => {
		handleFormChange();
	}, 500);

	const url = props.isFromDocumentsPage
		? `${process.env.REACT_APP_API_HOST}/v2/files/upload`
		: `${process.env.REACT_APP_API_HOST}/v2/emails/attachments/upload`;
	const isMergeTagsLoading = emailThreadMergeTagVariables.length === 0;
	const isSkeletonLoading =
		process.env.NODE_ENV !== "test"
			? !process.env.REACT_APP_TINY_MCE ||
			  process.env.REACT_APP_TINY_MCE.length === 0
			: false ||
			  !props.emailThreadMessage ||
			  (props.emailThreadMessage &&
					!!!props.isFromDocumentsPage &&
					props.emailThreadMessage.account_id.length === 0);
	const defaultEmailPreference = getDefaultEmailPreference();

	const recipientOptions = getRecipientOptions();

	const userEmailIntegrationObjValue = userCompany.integrations?.email?.find(
		e => e.user_id === userData.id
	);

	const showConnectedInbox =
		sendDocUsingNylasFlag && props.isFromDocumentsPage;

	const isDocumentPinProtected =
		props.isDocumentMessage && currentActiveDocument?.is_pin_protected;

	const isOrderForm = isGivenDocumentOrderForm(currentActiveDocument);

	const showExternalEmail = props.isDocumentMessage && !isOrderForm;

	const recipientTagRender = (props: any) => {
		const { label, value, onClose } = props;
		const hasExternalEmail =
			showExternalEmail &&
			!recipientOptions.some(recipient => recipient.value === value);
		return (
			<ZTag
				className={
					hasExternalEmail ? "external-email-recipient-tag" : ""
				}
				closable={isNewDocumentSendView}
				onClose={onClose}
			>
				{label}
			</ZTag>
		);
	};
	const toFieldValue: string[] | string = props.form.getFieldValue("to");
	const toEmailsValue =
		typeof toFieldValue === "string"
			? toFieldValue.trim().split(",")
			: toFieldValue || [];
	const hasExternalEmail =
		showExternalEmail &&
		!!toEmailsValue?.some(
			value =>
				!recipientOptions.some(recipient => recipient.value === value)
		);
	const hasCCAndBCCFields = !(
		props.isDocumentMessage && isNewDocumentSendView
	);
	const isToFieldDisabled = showExternalEmail && !isNewDocumentSendView;

	const defaultRecipientList = isSendDocumentEmailGuideActive
		? recipientOptions.map(recipient => recipient.value)
		: props.defaultRecipients ?? [];

	const sendButton = (
		<ZButton
			type="primary"
			htmlType="submit"
			id={targetId}
			loading={
				isLoading ||
				emailThreadMessageFileUploading ||
				emailThreadMessageEditorLoading ||
				isLoadingState
			}
		>
			Send
		</ZButton>
	);

	const sendButtonWithGuide =
		SendDocumentEmailGuideUI &&
		props.isDocumentMessage &&
		isSendDocumentEmailGuideActive ? (
			<SendDocumentEmailGuideUI>{sendButton}</SendDocumentEmailGuideUI>
		) : (
			sendButton
		);

	return (
		<ZDrawer
			visible={props.visible}
			closable={true}
			destroyOnClose={true}
			onClose={handleCancel}
			className="email-thread-message-drawer zomentum-drawer"
			zIndex={isSendDocumentEmailGuideActive ? 900 : 1000}
			title={
				<Row>
					<Col span={24}>
						<div className="drawer-title-container">
							<Skeleton
								loading={!props.emailThreadMessage}
								active
								title
								paragraph={false}
							>
								<div className="drawer-title">
									{!props.isNewThread && (
										<Fragment>
											<span className="text-bold">
												Reply:{" "}
											</span>
											<span>
												{props.emailThreadMessage
													?.subject || "[NO SUBJECT]"}
											</span>
										</Fragment>
									)}
									{props.isNewThread && (
										<Fragment>
											<span>Send Email</span>
										</Fragment>
									)}
								</div>
							</Skeleton>
						</div>
					</Col>
				</Row>
			}
			data-testid="email-thread-message-drawer"
		>
			<Form
				layout="horizontal"
				labelCol={{ xs: 6, sm: 4, md: 3, lg: 2, xl: 2, xxl: 2 }}
				wrapperCol={{
					xs: 18,
					sm: 20,
					md: 21,
					lg: 22,
					xl: 22,
					xxl: 22
				}}
				onSubmit={onSubmit}
				autoComplete="off"
				className="email-thread-message-drawer-form"
				onClickCapture={handleFormChange}
			>
				<div className="drawer-form-container">
					<Skeleton
						loading={isSkeletonLoading}
						active
						paragraph={{ rows: 12 }}
					>
						<Row align="middle">
							<Col span={24}>
								<Form.Item
									label="From"
									labelAlign="left"
									className="recipients-from"
								>
									{props.form.getFieldDecorator("from", {
										rules: [
											{
												message:
													"Please select email id"
											}
										],
										initialValue: defaultEmailPreference
									})(
										<Select<string>
											getPopupContainer={trigger =>
												trigger.parentNode
											}
											size="small"
											data-testid="from"
											dropdownClassName="from-email-select-dropdown"
										>
											{defaultEmailPreference ===
												process.env
													.REACT_APP_DEFAULT_EMAIL && (
												<Select.Option
													key={
														process.env
															.REACT_APP_DEFAULT_EMAIL
													}
													value={
														process.env
															.REACT_APP_DEFAULT_EMAIL ??
														"noreply@zomentum.com"
													}
												>
													{`${userData.name.full} <${process.env.REACT_APP_DEFAULT_EMAIL}>`}
												</Select.Option>
											)}
											{showConnectedInbox &&
												userEmailIntegrationObjValue && (
													<Select.Option
														value={formatNylasIntegratedEmailId(
															userEmailIntegrationObjValue.email
														)}
													>{`${userData.name.full} <${userEmailIntegrationObjValue.email}>  [ Connected Inbox ]`}</Select.Option>
												)}
											{!!props.isFromDocumentsPage
												? dkimConnectedEmails.length >
														0 &&
												  dkimConnectedEmails.map(
														(email, index) => {
															return (
																<Select.Option
																	key={index}
																	value={
																		email.email ??
																		undefined
																	}
																>
																	{`${
																		email.name
																	} <${
																		email.email ??
																		"No Email"
																	}>`}
																</Select.Option>
															);
														}
												  )
												: userEmailIntegrationObj?.email_aliases?.map(
														(alias, index) => {
															return (
																<Select.Option
																	key={index}
																	value={
																		alias.email ??
																		""
																	}
																>
																	{alias.email ??
																		"<No Email>"}
																</Select.Option>
															);
														}
												  )}
											{!props.isFromDocumentsPage &&
												userEmailIntegrationObj?.email && (
													<Select.Option
														value={
															userEmailIntegrationObj.email
														}
													>
														{
															userEmailIntegrationObj.email
														}
													</Select.Option>
												)}
										</Select>
									)}
									{hasCCAndBCCFields && (
										<div className="recipients-toggle">
											<div
												aria-disabled={
													isDocumentPinProtected
												}
												className={`
													${showCcRecipients ? "recipients-cc-toggle active" : "recipients-cc-toggle"} ${
													isDocumentPinProtected
														? "bg-gray-3 text-gray-7 pointer-events-none"
														: ""
												}`}
												onClick={() =>
													!isDocumentPinProtected
														? toggleCcRecipients()
														: null
												}
												data-testid="cc"
											>
												CC
											</div>
											<div
												aria-disabled={
													isDocumentPinProtected
												}
												className={`${
													!isMobileView ? "ml-3 " : ""
												}${
													showBccRecipients
														? "recipients-bcc-toggle active"
														: "recipients-bcc-toggle"
												} ${
													isDocumentPinProtected
														? "bg-gray-3 text-gray-7 pointer-events-none"
														: ""
												}`}
												onClick={() =>
													!isDocumentPinProtected
														? toggleBccRecipients()
														: null
												}
												data-testid="bcc"
											>
												BCC
											</div>
										</div>
									)}
								</Form.Item>
								<div ref={recipientRef}>
									<Form.Item
										label="To"
										labelAlign="left"
										className="recipients-to"
										extra={
											!defaultRecipientList?.length &&
											!!props.purchaseOrderId?.length ? (
												<ZTypography.ZText
													color={EColors.RED}
													colorVariant={6}
												>
													Email added here will be
													updated under the supplier
													upon sending the Purchase
													Order.
												</ZTypography.ZText>
											) : undefined
										}
									>
										{props.form.getFieldDecorator("to", {
											rules: [
												{
													required: true,
													validator: (_, values) =>
														handleEmailValidation(
															values,
															EmailRecipientsTypes.TO
														)
												}
											],
											initialValue: Array.isArray(
												defaultRecipientList
											)
												? defaultRecipientList
												: typeof defaultRecipientList ===
												  "string"
												? [defaultRecipientList]
												: []
										})(
											<ZSelect
												mode="tags"
												placeholder="Please add recipients"
												tokenSeparators={[",", " "]}
												autoClearSearchValue={true}
												dropdownClassName={`
														${props.isNewThread ? "" : "display-none"} ${
													!recipientOptions?.length &&
													recipientSearch.length === 0
														? "display-none"
														: ""
												}
													`}
												loading={isLoading}
												data-testid="recipients-select"
												maxTagCount={
													props.isFromDocumentsPage
														? shouldCollapse
															? "responsive"
															: undefined
														: "responsive"
												}
												disabled={isToFieldDisabled}
												onSearch={
													handleRecipientSearchStringChange
												}
												style={{ width: "98%" }}
												filterOption={(input, option) =>
													option?.children
														?.toLowerCase()
														?.includes(
															input?.toLowerCase()
														)
												}
												onSelect={handleSelect}
												selectOptions={recipientOptions}
												tagRender={recipientTagRender}
											/>
										)}
										{!hasCCAndBCCFields && (
											<ZTooltip
												title="Each recipient will recieve a seperate email"
												placement="left"
											>
												<span>
													<ZIcon
														name={EIcons.INFOCIRCLE}
														colorVariant={6}
														size="sm"
														className="mx-2"
													/>
												</span>
											</ZTooltip>
										)}
									</Form.Item>
								</div>
							</Col>
							{showCcRecipients && (
								<Col span={24}>
									<Form.Item
										label="CC"
										labelAlign="left"
										className="recipients-cc"
									>
										{props.form.getFieldDecorator("cc", {
											rules: [
												{
													required: false,
													validator: (_, values) =>
														handleEmailValidation(
															values,
															EmailRecipientsTypes.CC
														)
												}
											],
											initialValue: new Array<string>()
										})(
											<ZSelect<string[]>
												getPopupContainer={trigger =>
													trigger.parentNode
												}
												disabled={
													isDocumentPinProtected
												}
												mode="tags"
												placeholder="Please add CC recipients"
												tokenSeparators={[",", " "]}
												autoClearSearchValue={true}
												notFoundContent={null}
												loading={isLoading}
												onSearch={
													handleRecipientSearchStringChange
												}
												filterOption={(input, option) =>
													option?.children
														?.toLowerCase()
														?.includes(
															input?.toLowerCase()
														)
												}
												onSelect={handleSelect}
												selectOptions={recipientOptions}
												data-testid="cc-select"
											/>
										)}
									</Form.Item>
								</Col>
							)}
							{showBccRecipients && (
								<Col span={24}>
									<Form.Item
										label="BCC"
										labelAlign="left"
										className="recipients-bcc"
									>
										{props.form.getFieldDecorator("bcc", {
											rules: [
												{
													required: false,
													validator: (_, values) =>
														handleEmailValidation(
															values,
															EmailRecipientsTypes.BCC
														)
												}
											],
											initialValue: new Array<string>()
										})(
											<ZSelect<string[]>
												getPopupContainer={trigger =>
													trigger.parentNode
												}
												disabled={
													isDocumentPinProtected
												}
												mode="tags"
												placeholder="Please add BCC recipients"
												tokenSeparators={[",", " "]}
												autoClearSearchValue={true}
												notFoundContent={null}
												loading={isLoading}
												onSearch={
													handleRecipientSearchStringChange
												}
												filterOption={(input, option) =>
													option?.children
														?.toLowerCase()
														?.includes(
															input?.toLowerCase()
														)
												}
												onSelect={handleSelect}
												selectOptions={recipientOptions}
												data-testid="bcc-select"
											/>
										)}
									</Form.Item>
								</Col>
							)}
							{props.isNewThread && (
								<Col span={24}>
									<div ref={subjectBlockContainerRef}>
										<Form.Item
											label="Subject"
											labelAlign="left"
											className="subject"
										>
											{!isMergeTagsLoading && (
												<Editor
													id={`${
														props.isNewThread
															? EmailThreadMessageEditorType.Compose
															: EmailThreadMessageEditorType.Reply
													}-subject`}
													apiKey={
														process.env
															.REACT_APP_TINY_MCE
													}
													init={{
														...TinyMceOptions,
														plugins: [],
														menubar: false,
														inline: true,
														loading:
															isLoadingState ||
															isLoading ||
															emailThreadMessageEditorLoading ||
															isMergeTagsLoading,
														setup: (
															editor: any
														) => {
															editor.on(
																"keydown",
																(
																	event: KeyboardEvent
																) => {
																	if (
																		event.keyCode ===
																		13
																	) {
																		event.preventDefault();
																	}
																}
															);
														},
														content_style: `
															.mce-content-body {
																font-size: 14px;
																font-family: 'Source Sans Pro';
															}
															#email-thread-message-compose-editor-subject p {
																margin: 0 0 0 0.7rem;
															}
															.merge-tag {
																background: #ffedb4;
																cursor: auto !important;
															}
														`,
														init_instance_callback:
															(editor: any) => {
																if (
																	props.defaultSubject
																) {
																	const convertedTextFromMergeTags: string =
																		props.useTemplate &&
																		props.defaultSubject
																			? convertTextToMergeTag(
																					emailThreadMergeTagVariables,
																					props.defaultSubject
																			  )
																			: props.defaultSubject;

																	editor.setContent(
																		updateMergeTagsDisplayName(
																			emailThreadMergeTagVariables,
																			convertedTextFromMergeTags
																		)
																	);
																}
															}
													}}
													onEditorChange={
														updateTextFromSubjectTinyMCEEditor
													}
													onInit={
														initializeEmailThreadMessageDrawerEditor
													}
												/>
											)}
										</Form.Item>
									</div>
								</Col>
							)}
						</Row>
						<div ref={textBlockContainerRef}>
							{!isMergeTagsLoading && (
								<Editor
									id={
										props.isNewThread
											? EmailThreadMessageEditorType.Compose
											: EmailThreadMessageEditorType.Reply
									}
									apiKey={process.env.REACT_APP_TINY_MCE}
									init={{
										...TinyMceOptions,
										plugins: TinyMcePlugins,
										placeholder: props.bodyPlaceholder,
										loading:
											isLoadingState ||
											isLoading ||
											emailThreadMessageEditorLoading ||
											isMergeTagsLoading,
										content_style: `
											.mce-content-body {
												font-family: 'Source Sans Pro';
												margin-left: 20px !important;
												min-height: 100px !important;
											}
											.merge-tag {
												background: #ffedb4;
												cursor: auto !important;
											}
										`,
										init_instance_callback: (
											editor: any
										) => {
											if (
												props.templateBody &&
												!!emailThreadMergeTagVariables?.length
											) {
												editor.setContent(
													updateMergeTagsDisplayName(
														emailThreadMergeTagVariables,
														props.templateBody
													)
												);
											}
											if (props.isFromDocumentsPage) {
												fetchSystemSendEmailTemplate();
											}
											initializeTinyMCEPrePastePrompt(
												editor
											);
										}
									}}
									onEditorChange={
										updateTextFromEmailBodyTinyMCEEditor
									}
									onInit={
										initializeEmailThreadMessageDrawerEditor
									}
									onKeyDown={debounceHandleFormChange}
								/>
							)}
						</div>

						<ZSection
							className="border-none ml-5 z-section-preview-info"
							shouldApplyLeftPaddingForChildren={false}
							bottomBorder={false}
							first={false}
						>
							{!!props.documentId?.length &&
								!!currentActiveDocument &&
								props.isDocumentMessage &&
								!emailThreadMessageEditorLoading &&
								(!systemSendEmailTemplate ||
									!!systemSendEmailTemplate.system_template_info) && (
									<Row className="w-3/4 bg-gray-3 mb-2 align-middle rounded-md">
										<Col span={1} className="pl-2">
											<ZIcon
												name={EIcons.IMAGE}
												size="sm"
											/>
										</Col>
										<Col
											span={23}
											className={`my-0.5 ${
												isMobileView ? "pl-4" : ""
											}`}
										>
											<ZText
												weight={EFontWeights.MEDIUM}
												colorVariant={8}
											>
												This email uses a template.
												Click Preview Email to view
												email before sending.
											</ZText>
										</Col>
									</Row>
								)}
							<div
								className={`${
									!!currentActiveEmailSignature?.body?.length
										? ""
										: "mb-4"
								} mt-4 font-medium text-gray-7`}
								dangerouslySetInnerHTML={{
									__html:
										currentActiveEmailSignature?.body ?? ""
								}}
							/>
						</ZSection>

						{hasExternalEmail && props.isDocumentMessage && (
							<div className="email-document-public-link-info-container">
								<ZIcon
									name={EIcons.INFOCIRCLE}
									colorVariant={6}
									size="sm"
									color={EColors.ORANGE}
									className="m-0"
								/>
								<ZText colorVariant={7} className="ml-2 text-0">
									The public sharing link will be enabled for
									this document. Viewers wont be able to
									comment, select items or accept/sign the
									document.
								</ZText>
							</div>
						)}

						{props.isDocumentMessage &&
							!!props.documentId?.length &&
							currentActiveDocument &&
							!systemSendEmailTemplate && (
								<div className="email-document-message-info-container">
									<ZButton
										type="default"
										htmlType="button"
										className="email-document-message-preview"
										onClick={previewDocument}
									>
										View Document
									</ZButton>
									<Popover
										placement="top"
										trigger="click"
										className="email-document-message-popover"
										content={
											<ZText className="email-document-message-popover-content">
												The recipient(s) of this email
												will see this button, which will
												open the document in a new
												browser tab
											</ZText>
										}
									>
										<ZIcon name={EIcons.INFOCIRCLE} />
									</Popover>
								</div>
							)}
						<div className="email-thread-message-files-container border-solid border-0 border-t border-b border-gray-5">
							<Row align="middle">
								<Col span={12}>
									<Upload
										name="file"
										id="file"
										method="POST"
										action={url}
										accept="*"
										headers={{
											Authorization: `Bearer ${
												(
													cache.get(
														ZomentumStorageKeys.Token,
														true
													) as AuthToken
												)?.token
											}`
										}}
										showUploadList={true}
										onChange={uploadEmailThreadFile}
										onRemove={deleteEmailThreadFile}
										beforeUpload={
											beforeUploadEmailThreadFile
										}
										className="email-thread-message-file-upload-container"
										fileList={listOfAttachments}
										data-testid="upload-attachment"
									>
										<div className="email-thread-upload-file-link">
											<ZIcon
												name={EIcons.UPLOADV2}
												size="sm"
											/>
											<ZText
												className="ml-2"
												weight={EFontWeights.MEDIUM}
												color={EColors.BLUE}
												colorVariant={6}
											>
												Upload Attachment
											</ZText>
										</div>
									</Upload>
								</Col>
							</Row>
						</div>
					</Skeleton>
					<div
						style={{
							position: "absolute",
							top: mergeTagDropdownY,
							left: mergeTagDropdownX,
							zIndex: 50
						}}
					>
						<ZMergeTagCascadeDropdown
							shouldAllowAddVariable={false}
							mergeTagSystemVariables={
								emailThreadMergeTagVariables
							}
							mergeTagCustomVariables={[]}
							visible={mergeTagDropdownVisible}
							onSubmit={handleSubmitMergeTagVariable}
							onClose={handleCloseMergeTagDropdown}
							MergeTagListToSkip={MergeTagListToSkip}
							isDocumentMessage={props.isDocumentMessage}
						/>
					</div>
				</div>
				<div className="ant-drawer-footer">
					{!isMobileView && (
						<div className="footer-activities">
							{props.isDocumentMessage &&
								!props.isFromEmailTemplatesPage && (
									<>
										<DocumentExpiration />
										<DocumentReminder />
									</>
								)}
							<div
								className={`footer-activities-text preview-email ${
									isPreviewEmailModalOpen ? "icon-active" : ""
								}`}
							>
								<ZButton
									type="link"
									onClick={verifyAndOpenPreviewModal}
									iconName={ETwoToneIcons.EYETWOTONE}
								>
									<ZText
										weight={EFontWeights.MEDIUM}
										className="truncate"
									>
										Preview Email
									</ZText>
								</ZButton>
							</div>

							{!props.isDocumentMessage && (
								<TrackEmail
									value={emailTracking}
									isTrackingEnabled={!!emailTracking}
									updateEmailTracking={
										updateEmailTrackingDetails
									}
								/>
							)}

							{props.isFromDocumentsPage ? (
								<Dropdown
									trigger={["click"]}
									overlayClassName="more-options-dropdown"
									overlay={
										<Menu>
											<Menu.Item
												onClick={
													showImportEmailTemplateModal
												}
												key={0}
											>
												{" "}
												<div className="menu-templates-label active">
													<TemplatesIcon />
													Templates
												</div>
											</Menu.Item>
										</Menu>
									}
									placement="topLeft"
								>
									<ZButton
										type="primary"
										ghost
										iconName={EIcons.CHEVRONDOWNV2}
										iconButton
										size="large"
										className="border-none text-blue-6 pt-0.5"
									/>
								</Dropdown>
							) : (
								!props.isFromEmailTemplatesPage && (
									<ZButton
										type="link"
										className="footer-activities-text templates-button"
										onClick={showImportEmailTemplateModal}
									>
										<TemplatesIcon />
										Templates
									</ZButton>
								)
							)}
							<EmailSignatureComponent
								updateCurrentActiveEmailSignature={
									handleCurrentActiveEmailSignature
								}
								currentActiveSignature={
									currentActiveEmailSignature
								}
							/>
						</div>
					)}
					<div
						className={`${
							isMobileView ? "flex justify-end w-full mb-2" : ""
						}`}
					>
						<ZButton
							type="default"
							htmlType="button"
							disabled={
								isLoading || emailThreadMessageFileUploading
							}
							onClick={handleCancel}
							className="margin-right-8px"
						>
							Close
						</ZButton>
						{sendButtonWithGuide}
					</div>
				</div>
			</Form>

			<ZModal
				title="Preview Email"
				centered={true}
				visible={isPreviewEmailModalOpen}
				onOk={closePreviewModal}
				onCancel={closePreviewModal}
				wrapClassName="preview-email-modal"
				footer={[
					<ZButton
						key="close-button-footer"
						onClick={closePreviewModal}
					>
						Close
					</ZButton>
				]}
				size="lg"
			>
				<Fragment>
					{emailPreviewContent()}
					{!!listOfAttachments.length && (
						<div className="mt-4">
							<ZText weight={EFontWeights.MEDIUM}>
								Uploaded attachments:
							</ZText>
							<ul>
								{listOfAttachments.map((attachment, index) => (
									<li key={`attachment-${index}`}>
										<ZText>{attachment.name}</ZText>
									</li>
								))}
							</ul>
						</div>
					)}
				</Fragment>
			</ZModal>

			<Modal
				wrapClassName="validate-email-modal"
				footer={[null]}
				centered
				closable={false}
				visible={isValidating}
			>
				<Spin tip="Checking for empty merge tags" spinning={true} />
			</Modal>
			<EmptyMergeTagsAlertModal
				visible={isEmptyMergeTagsAlertModalOpen}
				closeModal={() => {
					closeEmptyMergeTagsAlertModal();
				}}
				emptyMergeTags={emptyMergeTagsState}
				isMergeTagMissing={!!emptyMergeTagsState.length}
				showEmptyFields={isEmptyMergeTagsAlertFromSendEmail}
				confirmText={
					isEmptyMergeTagsAlertFromSendEmail
						? "Proceed with Sending Email"
						: "Proceed with Preview Email"
				}
				confirmFromModal={
					isEmptyMergeTagsAlertFromSendEmail
						? shouldReplaceWithBlank =>
								continueToSendEmail(shouldReplaceWithBlank)
						: shouldReplaceWithBlank =>
								continueToPreviewEmail(shouldReplaceWithBlank)
				}
			/>
			<ImportEmailTemplateModal
				visible={isImportEmailTemplateModalOpen}
				onSelect={handleSelectEmailTemplate}
				onCancel={closeImportEmailTemplateModal}
			/>

			<Modal
				title="Missing mandatory merge tags"
				closable
				centered
				visible={isMandatoryMergeTagModalOpen}
				onCancel={closeMandatoryMergeTagModal}
				wrapClassName="mandatory-merge-tag-modal"
				footer={[
					<ZButton key={0} onClick={closeMandatoryMergeTagModal}>
						Close
					</ZButton>
				]}
			>
				<ZText
					style={{
						marginBottom: "15px",
						paddingBottom: "10px"
					}}
				>
					Send Document Email should contain&nbsp;
					<ZText className="merge-tag mceNonEditable">
						{MERGE_TAG_START}Receiver.Document.Url
						{MERGE_TAG_END}
					</ZText>
					&nbsp; merge tag.
				</ZText>
			</Modal>

			<Modal
				title="Address not authorized"
				closable
				centered
				visible={emailExpiredModalVisible}
				onCancel={closeEmailExpiredModal}
				footer={[
					<ZButton
						key={0}
						type="link"
						onClick={() =>
							history.push(ZomentumRoutes.EmailSettings)
						}
					>
						Reauthorize
					</ZButton>,
					<ZButton
						key={1}
						type="primary"
						onClick={handleEmailExpiration}
					>
						Use Default
					</ZButton>
				]}
			>
				{emailExpiredMessage !== "" ? (
					emailExpiredMessage?.split("Bad Request: ")[1]
				) : (
					<ZText>
						The address you are attempting to send the document from
						is no longer authorized. Please reauthorize the email
						address or send via Zomentum’s default email address{" "}
						<ZText weight={EFontWeights.MEDIUM}>
							({process.env.REACT_APP_DEFAULT_EMAIL})
						</ZText>
					</ZText>
				)}
			</Modal>
		</ZDrawer>
	);
};

const ConnectedForm = Form.create<Props>({
	name: "email_thread_messages_form"
})(EmailThreadMessageDrawer);

export default ConnectedForm;
